<h1 *ngIf="data.title" mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p style="white-space: pre-wrap">{{data.message}}</p>
</div>
<div mat-dialog-actions align="center" >
  <button mat-button *ngIf="!data.isConfirmation" (click)="closeDialog()">Ok</button>
  <button mat-button *ngIf="data.isConfirmation" [mat-dialog-close]="false">CANCEL</button>
  <button mat-flat-button color="primary" *ngIf="data.isConfirmation" [mat-dialog-close]="true" color="primary" class="yesAlert">{{data.confirmButtonName}}</button>
</div>
